import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { EpubPlayerComponent } from './sunbird-epub-player.component';
import { EpubViewerComponent } from './epub-viewer/epub-viewer.component';
// import { SunbirdPlayerSdkModule  } from '@project-sunbird/sunbird-player-sdk-v9';
import { SunbirdPlayerSdkModule  } from '@dicdikshaorg/player-sdk-v9';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ToastrComponent } from './toastr/toastr.component';




@NgModule({
  declarations: [EpubPlayerComponent, EpubViewerComponent, ToastrComponent],
  imports: [
    CommonModule,
    SunbirdPlayerSdkModule,
    HttpClientModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [EpubPlayerComponent]
})
export class SunbirdEpubPlayerModule { }
